import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18nBase from './i18n';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { CookieConsent } from './components/CookieConsent';
import { WhatsAppFab } from './components/WhatsAppFab';
import { ScrollToTop } from './components/ScrollToTop';
import { ScrollManager } from './lib/ScrollManager';
import { useLocale } from './lib/use-locale';
import './styles/global.css';
import './styles/pages.css';

/**
 * Root layout. Locale is derived from the URL path (not params) via
 * `useLocale()`. A cloned i18n instance is created per render for
 * deterministic SSR.
 */
export function App() {
  const locale = useLocale();

  const i18n = useMemo(() => i18nBase.cloneInstance({ lng: locale }), [locale]);

  return (
    <I18nextProvider i18n={i18n}>
      <AppChrome />
    </I18nextProvider>
  );
}

function AppChrome() {
  const { t } = useTranslation();
  return (
    <>
      <a href="#main" className="skip-link">
        {t('nav.skipToContent')}
      </a>
      <ScrollManager />
      <SiteHeader />
      <Outlet />
      <SiteFooter />
      <WhatsAppFab />
      <ScrollToTop />
      <CookieConsent />
    </>
  );
}

export default App;
